// デフォルトのアニメーション設定（全テンプレート共通のベース）
export default {
  config: {
    // 'overlay': position:fixed のオーバーレイ内に配置（スクロールに追従）
    // 'body': body に直接配置（スクロールに追従しない、ページ上の絶対位置）
    mode: 'body',
    interval: { min: 1000, max: 2000 },
    duration: { min: 4000, max: 8000 },
    baseWidth: 1440,
    size: { min: 100, max: 350 },
    speed: { min: 30, max: 100 },
    fade: { in: 600, out: 600 },
    // スケーリングの塩梅調整
    // scaleMin: 画面が0pxでも最低このスケール値を保証（0.0〜1.0）
    // scaleCurve: 縮小カーブの強さ（1.0=線形、<1.0=小さい画面で大きめに、>1.0=小さい画面でより小さく）
    scaleMin: 0.3,
    scaleCurve: 0.6,
  },
  // weight: グループの出現確率（相対値、合計が100である必要はない）
  animations: [
    {
      weight: 40,
      items: [
        {
          path: 'svganim/a_chocho_1/data.json',
          direction: 'up-left',
          randomColor: true,
          lightness: { min: 40, max: 70 },
        },
        {
          path: 'svganim/a_chocho_2/data.json',
          direction: 'down-left',
          randomColor: true,
          lightness: { min: 40, max: 70 },
        },
        {
          path: 'svganim/a_chocho_3/data.json',
          direction: 'up-left',
          randomColor: true,
          lightness: { min: 40, max: 70 },
        },
        {
          path: 'svganim/a_chocho_4/data.json',
          direction: 'up-right',
          randomColor: true,
          lightness: { min: 40, max: 70 },
        },
        {
          path: 'svganim/a_chocho_5/data.json',
          direction: 'right',
          randomColor: true,
          lightness: { min: 40, max: 70 },
        },
        {
          path: 'svganim/a_chocho_6/data.json',
          direction: 'down-right',
          randomColor: true,
          lightness: { min: 40, max: 70 },
        },
      ],
    },
    {
      weight: 15,
      items: [
        {
          path: 'svganim/a_futaba_1/data.json',
          direction: 'none',
          randomColor: false,
        },
        {
          path: 'svganim/a_futaba_2/data.json',
          direction: 'none',
          randomColor: false,
        },
        {
          path: 'svganim/a_futaba_3/data.json',
          direction: 'none',
          randomColor: false,
        },
        {
          path: 'svganim/a_futaba_4/data.json',
          direction: 'none',
          randomColor: false,
        },
        {
          path: 'svganim/a_futaba_5/data.json',
          direction: 'none',
          randomColor: false,
        },
        {
          path: 'svganim/a_futaba_6/data.json',
          direction: 'none',
          randomColor: false,
        },
        {
          path: 'svganim/a_futaba_7/data.json',
          direction: 'none',
          randomColor: false,
        },
        {
          path: 'svganim/a_futaba_8/data.json',
          direction: 'none',
          randomColor: false,
        },
        {
          path: 'svganim/a_futaba_9/data.json',
          direction: 'none',
          randomColor: false,
        },
        {
          path: 'svganim/a_futaba_10/data.json',
          direction: 'none',
          randomColor: false,
        },
        {
          path: 'svganim/a_futaba_11/data.json',
          direction: 'none',
          randomColor: false,
        },
        {
          path: 'svganim/a_futaba_12/data.json',
          direction: 'none',
          randomColor: false,
        },
        {
          path: 'svganim/a_futaba_13/data.json',
          direction: 'none',
          randomColor: false,
        },
      ],
    },
    {
      weight: 15,
      items: [
        {
          path: 'svganim/a_tamago_1/data.json',
          direction: 'none',
          randomColor: false,
        },
        {
          path: 'svganim/a_tamago_2/data.json',
          direction: 'none',
          randomColor: false,
        },
        {
          path: 'svganim/a_tamago_3/data.json',
          direction: 'none',
          randomColor: false,
        },
        {
          path: 'svganim/a_tamago_4/data.json',
          direction: 'none',
          randomColor: false,
        },
      ],
    },
  ],
};
